import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

declare global {
  interface Window {
    Intercom: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  private booted = false;

  boot(profile: any): void {
    if (!profile) {
      return;
    }
    if (typeof window === 'undefined' || !window.Intercom) {
      return;
    }
    window.Intercom('boot', {
      app_id: environment.intercom.appId,
      user_id: profile.id,
      user_hash: profile.intercom_hash,
      name: profile.full_name,
      email: profile.email,
      user_role: profile.role?.title,
      created_at: this.toUnix(profile.created_at),
      avatar: {
        type: 'avatar',
        image_url: profile.profile_image_url,
      },
      company: {
        company_id: `${environment.domain}_${profile.company?.id}`,
        created_at: this.toUnix(profile.company?.created_at),
        name: profile.company?.company_name,
      },
    });
    this.booted = true;
  }

  update(): void {
    if (!this.booted) {
      return;
    }
    if (typeof window === 'undefined' || !window.Intercom) {
      return;
    }
    window.Intercom('update');
  }

  shutdown(): void {
    if (!this.booted) {
      return;
    }
    if (typeof window === 'undefined' || !window.Intercom) {
      return;
    }
    window.Intercom('shutdown');
    this.booted = false;
  }

  private toUnix(date: any): number | undefined {
    if (!date) {
      return undefined;
    }
    const ts = new Date(date).getTime();
    if (isNaN(ts)) {
      return undefined;
    }
    return Math.floor(ts / 1000);
  }
}
